import InsideSalesAcceptedButton from './InsideSalesAcceptedButton';

export default InsideSalesAcceptedButton;
